// extracted by mini-css-extract-plugin
export default {"diffHeaderWrapper":"Diff-module__diffHeaderWrapper--rsdD4"};